import { SsmValueCell } from "../SsmPage/SsmValueCell";
import { renderStatus, statusColor, type KioskParam, type KioskRow } from "./kioskBuilder";

const LEGEND_STATUSES: KioskRow["status"][] = ["connected", "queued", "problem", "closed", "not-connected"];

const STATUS_DESCRIPTIONS: Record<KioskRow["status"], string> = {
  connected: "Live session running on the kiosk.",
  queued: "Waiting in queue for a session.",
  problem: "Should be open per opening hours, but has no session — needs attention.",
  closed: "Outside configured opening hours.",
  "not-connected": "No session, and opening hours can't be evaluated (missing/unparsable config).",
  unknown: "Demand data unavailable for this environment.",
};

function StatusLegend() {
  return (
    <dl class="kiosk-status-legend">
      {LEGEND_STATUSES.map((status) => (
        <>
          <dt style={{ backgroundColor: statusColor(status) }}>{renderStatus(status)}</dt>
          <dd>{STATUS_DESCRIPTIONS[status]}</dd>
        </>
      ))}
    </dl>
  );
}

export function KioskDetailPanel({ kiosk, params }: { kiosk: KioskRow | null; params: KioskParam[] }) {
  if (!kiosk) {
    return (
      <div class="kiosk-detail-panel">
        <StatusLegend />
        <p class="kiosk-detail-placeholder">Click a kiosk to see its details.</p>
      </div>
    );
  }

  return (
    <div class="kiosk-detail-panel">
      <StatusLegend />
      <div class="kiosk-detail-selected">
        <h3>{kiosk.id}</h3>
        <dl class="kiosk-detail-summary">
          <dt>Solution</dt>
          <dd>{kiosk.solution ?? "—"}</dd>
          <dt>Environment</dt>
          <dd>{kiosk.environment ?? "—"}</dd>
          <dt>Status</dt>
          <dd style={{ backgroundColor: statusColor(kiosk.status) }}>{renderStatus(kiosk.status)}</dd>
        </dl>
        {params.length > 0 && (
          <table class="ssm-params-table">
            <thead>
              <tr>
                <th>Parameter</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {params.map((p) => (
                <tr key={p.key} class={p.type === "SecureString" ? "secure-string" : ""}>
                  <td>{p.key}</td>
                  <td class="ssm-value-cell">
                    <SsmValueCell type={p.type} value={p.value} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
